import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import { IsValidToken, GetCustomerInfo, GetCountries, GetStatesbyCountry } from "../../services/AuthenticationService";
import { GetGenericFormProperties, GenericDeposit } from "../../services/DepositService";
import Loading from '../helpers/Loader';
import { onlyNumbers, BonusString } from '../helpers/common';
import clientInformation, { getClientItem } from '../login/ClientInfo';
import Bonus from '../Bonus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isMobile } from 'react-device-detect';
import { faCopy, faUsd, faMoneyBill, faAddressBook, faPhone, faUser, faThLarge, faEnvelopeOpen, faGlobe, faBuilding, faLocationArrow, faAddressCard, faUniversity, faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons'
import ReactDOMServer from 'react-dom/server';

export const GenericMethods = () => {
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const navigate = useNavigate();
    const { id } = useParams();
    const [arrayGenericForm, setArrayGenericForm] = useState([]);
    const [arrayCustomerInfo, setArrayCustomerInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [arrayRegularDeposits, setRegularDeposits] = useState(JSON.parse(getClientItem('ArrayRegularMethods')).filter(function (element) { return element.ProcessorID == id; })[0]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [arrayCountries, setArrayCountries] = useState([]);
    const [arrayStates, setArrayStates] = useState([]);
    const [stateCode, setStateCode] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [currencyCode, setCurrencyCode] = useState('');
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');
    const [language, setLanguage] = useState('us');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(async function (response) {
            await GetCountries(getClientItem('Token')).then(async function (response) {
                var i = 0;
                const filtered = response.Authentication.map(item => {
                    const {
                        Code,
                        Name } = item;

                    return { Key: i++, Code, Name }
                });
                setArrayCountries(filtered);
                setCountryCode('US');
                setCurrencyCode(clientInfo.CurrencyCode);
                setStateCode(clientInfo.StateCode);
                handleStatebyCountry('US', true);
                console.log(arrayRegularDeposits);
                if (arrayRegularDeposits.DepositName == 'MidasRed' ||
                    arrayRegularDeposits.DepositName == 'Disashop' ||
                    arrayRegularDeposits.DepositName == 'TransferenciaBancaria'){
                    setLanguage('es');
                }
                else {
                    setLanguage('us');
                }
                
            });

            GetGenericDepositFormProperties();
            CustomerInfo();
        })
            .catch(function (error) {
                navigate('/expired/');
            })
    }, [])
  
    async function CustomerInfo() {
        await GetCustomerInfo(getClientItem('Token')).then(function (response) {
            if (response.Authentication.ErrorDescription !== "Invalid input data") {
                setArrayCustomerInfo(response.Authentication);

            }
            else {
                clientInfo.Error = false;
                Alerts.ShowAlert(
                    'Error',
                    language === 'es'
                        ? 'Error al obtener la informaci�n del cliente: ' + response.Authentication.ErrorDescription
                        : 'Error getting customer info: ' + response.Authentication.ErrorDescription,
                    'error'
                );

            }
        })
            .catch(function (error) {
                clientInfo.Error = false;
                Alerts.ShowAlert(
                    'Error',
                    language === 'es'
                        ? 'Error al obtener la informaci�n del cliente: ' + error.response.data.Authentication.ErrorDescription
                        : 'Error getting customer info: ' + error.response.data.Authentication.ErrorDescription,
                    'error'
                );
            })
    }

    async function GetGenericDepositFormProperties() {
        var DepositData = {
            "Token": getClientItem('Token'),
            "ProcessorID": arrayRegularDeposits.ProcessorID
        };
        await GetGenericFormProperties(DepositData).then(async function (response) {

            await setArrayGenericForm(response.Authentication);
            if (response.Authentication.ErrorDescription !== null) {
                Alerts.ShowAlert('Error', response.Authentication.ErrorDescription, 'error');
                navigate('/deposits/');
            }
            await setIsLoading(false);

        })
            .catch(function (error) {
                setIsLoading(false);
                Alerts.ShowAlert('Error', error.response.data.Authentication.ErrorDescription, 'error');
            })


    }

    async function doGenericDeposit(data) {
        await GenericDeposit(data)
            .then(async function (response) {
                var transactionID = response.Authentication.TransactionID;
                var htmlResponse = response.Authentication.HtmlResponse;
                var custom = '';
                if (language == 'es') {
                    custom = `<br/>Su transacci&oacute;n ha sido iniciada correctamente.<br/>
                      Por favor, incluya en el concepto o memo:<br/>
                      ID de la transacci&oacute;n: <strong>${transactionID}</strong>&nbsp;<span id="copy-btn">Copiar</span><br/>
                      <span id="copy-wallet" style="display:none;"></span>
                      <br/>`;
                }
                else {
                    custom = `
                            <br/>
                            <div class="deposit-status-text">
                              Your transaction has been initiated.<br/>
                              Please send your payment to:
                            </div>

                            <div class="deposit-copy-block">

                              <div class="deposit-line">
                                <div class="deposit-label">Wallet</div>
                                <div class="deposit-value">
                                  <span class="deposit-text">${arrayGenericForm.txtIdentifier}</span>
                                  <span id="copy-wallet"></span>
                                </div>
                              </div>
                              <div class="deposit-status-text" style="margin-top:10px;">
                                and include in the memo:
                              </div>

                              <div class="deposit-line">
                                <div class="deposit-label">Tnx ID</div>
                                <div class="deposit-value">
                                  <span class="deposit-text">${transactionID}</span>
                                  <span id="copy-btn"></span>
                                </div>
                              </div>
                            </div>
                            <br/>
                            <style>
                            .deposit-status-text {
                                font-size: 0.95em;
                                color: #334155;
                                text-align: center;
                                line-height: 1.4em;
                            }

                            .deposit-copy-block {
                                margin-top: 14px;
                                display: flex;
                                flex-direction: column;
                                gap: 12px;
                                text-align: left;
                            }

                            .deposit-line {
                                background: #f8fafc;
                                border: 1px solid #e2e8f0;
                                border-radius: 12px;
                                padding: 12px 14px;
                            }

                            .deposit-label {
                                font-size: 0.78em;
                                font-weight: 700;
                                color: #64748b;
                                margin-bottom: 6px;
                                text-transform: uppercase;
                                letter-spacing: 0.04em;
                            }

                            .deposit-value {
                                display: flex !important;
                                align-items: center !important;
                                justify-content: space-between !important;
                                flex-wrap: nowrap !important; /* IMPORTANT */
                                width: 100% !important;
                            }

                            .deposit-text {
                                flex: 1 !important;
                                min-width: 0 !important;
                                white-space: nowrap !important;
                                overflow: hidden !important;
                                text-overflow: ellipsis !important;
                            }

                            .copy-icon-wrap {
                                display: inline-flex;
                                align-items: center;
                                gap: 6px;
                                cursor: pointer;
                                padding: 5px 10px;
                                border-radius: 10px;
                                background: #ffffff;
                                border: 1px solid #e2e8f0;
                                transition: all 0.15s ease;
                                user-select: none;
                            }

                                .copy-icon-wrap:hover {
                                    background: #f1f5f9;
                                    border-color: #cbd5e1;
                                }

                                .copy-icon-wrap:active {
                                    transform: scale(0.92);
                                }

                            .copy-success-msg {
                                font-size: 0.78em;
                                color: #22c55e;
                                font-weight: 700;
                                opacity: 0;
                                transform: translateY(4px);
                                transition: opacity 0.2s ease, transform 0.2s ease;
                                white-space: nowrap;
                            }

                                .copy-success-msg.show {
                                    opacity: 1;
                                    transform: translateY(0);
                                }

                            #copy-wallet,
                            #copy-btn {
                                display: inline-flex !important;
                                flex-shrink: 0 !important;
                            }
                            </style>
                            `;
                }
                const title = language === 'es' ? 'Estado del dep\u00F3sito' : 'Deposit Status';
                const status = language === 'es'
                    ? (htmlResponse?.toLowerCase() === 'pending'
                        ? 'Pendiente'
                        : htmlResponse?.toLowerCase() === 'rejected'
                            ? 'Rechazado'
                            : htmlResponse)
                    : htmlResponse;

                if (language == 'es') {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen(title, status + custom, 'info');
                    else
                        Alerts.ShowAlert(title, status + custom, 'info');
                }
                else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Deposit Status', (arrayGenericForm.txtIdentifier != '' ? htmlResponse + custom : htmlResponse), 'info');
                    else
                        Alerts.ShowAlert('Deposit Status', (arrayGenericForm.txtIdentifier != '' ? htmlResponse + custom : htmlResponse), 'info');
                }

                

                setTimeout(() => {
                    const copyIconHTML = ReactDOMServer.renderToString(
                        <FontAwesomeIcon icon={faCopy} style={{ fontSize: '1.2em', marginLeft: '5px', color: '#22c55e' }} />
                    );

                    function setupCopyButton(elementId, valueToCopy) {
                        const el = document.getElementById(elementId);
                        if (!el) return;

                        // Wrapper with icon + label
                        el.innerHTML = `
                            <span class="copy-icon-wrap">
                                ${copyIconHTML}
                                <span class="copy-label" id="${elementId}-label">Copy</span>
                            </span>`;

                        const wrapper = el.querySelector('.copy-icon-wrap');
                        const label = document.getElementById(`${elementId}-label`);

                        wrapper.addEventListener('click', () => {
                            navigator.clipboard.writeText(valueToCopy).then(() => {
                                label.textContent = "Copied";
                                setTimeout(() => {
                                    label.textContent = "Copy";
                                }, 1800);
                            }).catch(() => {
                                // Fallback for older browsers
                                const textarea = document.createElement('textarea');
                                textarea.value = valueToCopy;
                                document.body.appendChild(textarea);
                                textarea.select();
                                document.execCommand('copy');
                                document.body.removeChild(textarea);

                                label.textContent = "Copied";
                                setTimeout(() => {
                                    label.textContent = "Copy";
                                }, 1800);
                            });
                        });
                    }

                    setupCopyButton('copy-btn', transactionID);
                    setupCopyButton('copy-wallet', arrayGenericForm.txtIdentifier);
                }, 100);
            })
            .catch(function (error) {
                setIsLoading(false);
                Alerts.ShowAlert('Error', error.response.data.Authentication.ErrorDescription, 'error');
            });
    }

    function copyTransactionID(transactionID) {
        navigator.clipboard.writeText(transactionID).then(() => {
            /*Alerts.ShowAlert('Copied!', ` ${transactionID} copied to clipboard.`, 'success');*/
        });
    }


    const handleStatebyCountry = async (selectedCountryCode, setState) => {
        await GetStatesbyCountry(selectedCountryCode).then(async function (response) {

            var i = 0;
            const filtered = response.Authentication.map(item => {
                const {
                    Code,
                    Name } = item;

                return { Key: i++, Code, Name }
            });
            setArrayStates(filtered);
            if (setState) {
                if (filtered.length > 1)
                    setStateCode(filtered[1].Code);
                else
                    setStateCode(filtered[0].Code);
            }
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { Amount, Identifier, GeneralID, FirstName, LastName, Phone, City, Address, Notes, Email, Address2, ZipCode } = Object.fromEntries(data.entries());
            if (Amount !== '') {
                if (parseFloat(Amount) > 0) {
                    setIsLoading(true);
                    setIsProcessing(true);
                    var formData = {
                        "Token": getClientItem('Token'),
                        "ProcessorID": arrayRegularDeposits.ProcessorID,
                        "CurrencyCode": currencyCode,
                        "Identifier": (Identifier !== undefined ? Identifier : ''),
                        "GeneralID": (GeneralID !== undefined ? GeneralID : ''),
                        "FirstName": (FirstName !== undefined ? FirstName : arrayCustomerInfo.Name),
                        "LastName": (LastName !== undefined ? LastName : arrayCustomerInfo.LastName),
                        "Phone": (Phone !== undefined ? Phone : arrayCustomerInfo.Phone),
                        "Email": (Email !== undefined ? Email : arrayCustomerInfo.Email),
                        "Address": (Address !== undefined ? Address : arrayCustomerInfo.Address),
                        "Address2": (Address2 !== undefined ? Address2 : arrayCustomerInfo.Address2),
                        "Country": countryCode,
                        "State": stateCode,
                        "City": (City !== undefined ? City : arrayCustomerInfo.City),
                        "ZipCode": (ZipCode !== undefined ? ZipCode : arrayCustomerInfo.ZipCode),
                        "Amount": Amount,
                        "IPv4Address": clientInfo.IPAddress,
                        "Notes": (Notes !== undefined ? Notes : ''),
                        "BonusList": BonusString(JSON.parse(getClientItem('ArrayBonus'))),
                    };

                    await doGenericDeposit(formData);
                    setIsProcessing(false);
                    setIsLoading(false);
                }
                else {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen(
                            'Deposit Status',
                            language === 'es' ? 'Monto no permitido' : 'amount not permitted',
                            'warning'
                        );
                    }
                    else {
                        Alerts.ShowAlert(
                            'Deposit Status',
                            language === 'es' ? 'Monto no permitido' : 'amount not permitted',
                            'warning'
                        );
                    }
                }

            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }

        }
    }

    if (isLoading) {
        return <Loading />;
    }

    const CurrencyOptions = [
        { key: "1", value: "USD", name: "USD" },
        { key: "2", value: "EUR", name: "EUR" },
        { key: "3", value: "GBP", name: "GBP" },
        { key: "4", value: "AUD", name: "AUD" },
        { key: "5", value: "DOP", name: "DOP" }
    ];

    return (
        <div className="main-content deposit container componentload">
            <div>
                <div className="tab-content clear">
                    <form onSubmit={handleSubmit} ng-submit="submitGeneric()">
                        <div className="row m-4">
                            <span className="icon-single-left txt-primary">
                                <img style={{ width: "100px", height: "100px" }} src={"data:image/svg+xml;base64," + arrayRegularDeposits?.ImageName} /> <span className="deposit-title">
                                    {language === 'es'
                                    ? `Dep\u00F3sito usando ${arrayRegularDeposits?.DepositID}`
                                    : `Deposit using ${arrayRegularDeposits?.DepositID}`
                                } </span>
                            </span>
                        </div>
                        {/*Fields */}
                        <div className="row">
                            <div className="col-xs-12">
                                <br />
                            </div>
                        </div>
                        <div className="row m3">
                            <div className="col-md-4 col-sm-4 col-xs-12 mb-3">
                                <div className="input-group" >
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faUsd} />
                                    </div>
                                    <select className="form-select" name="Currency" onChange={(event) => { setCurrencyCode(event.target.value) }} required disabled
                                        tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the Currency"                                        >
                                        {CurrencyOptions.map((item) => <option key={item.Key} selected={item.value === clientInfo.CurrencyCode} value={item.value}>{item.name}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4 col-xs-12  mb-3">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faMoneyBill} />
                                    </div>
                                    <input type="number" className="form-control" aria-label="Amount (to the nearest dollar)" onKeyPress={(event) => onlyNumbers(event)} placeholder={language === 'es' ? 'Monto' : 'Amount'}
                                        name="Amount" required={arrayGenericForm.Amount.Required} value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0}
                                        max={arrayRegularDeposits.MaxDeposit === 0 ? MAXLIMIT : arrayRegularDeposits.MaxDeposit} min={arrayRegularDeposits.MinDeposit === 0 ? 1 : arrayRegularDeposits.MinDeposit} />

                                </div>
                                <p className="center-block d-flex flex-row ml-2 limit-text-center">
                                    {language === 'es'
                                        ? `Dep\u00F3sito m\u00EDnimo ${arrayRegularDeposits.MinDeposit === 0 ? 1 : arrayRegularDeposits.MinDeposit} ${clientInfo.CurrencyCode} m\u00E1ximo ${arrayRegularDeposits.MaxDeposit === 0 ? 'Sin l\u00EDmite' : arrayRegularDeposits.MaxDeposit + ' ' + clientInfo.CurrencyCode}`
                                        : `Deposit Minimum ${arrayRegularDeposits.MinDeposit === 0 ? 1 : arrayRegularDeposits.MinDeposit} ${clientInfo.CurrencyCode} Maximum ${arrayRegularDeposits.MaxDeposit === 0 ? 'No Limit' : arrayRegularDeposits.MaxDeposit + ' ' + clientInfo.CurrencyCode}`
                                    }
                                </p>
                            </div>
                            {arrayGenericForm.Identifier.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3" >
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faAddressBook} />
                                    </div>
                                    <input type="text" className="form-control" name="Identifier" disabled={!arrayGenericForm.Identifier.Editable}
                                        aria-label="Account" placeholder={arrayGenericForm.lblIdentifier === '' ? "Account" : arrayGenericForm.lblIdentifier}
                                        value={arrayCustomerInfo.CountryCode === 'DO' ? clientInfo.CustomerPIN : (arrayGenericForm.txtIdentifier === '' ? "" : arrayGenericForm.txtIdentifier)}  />
                                </div>
                                {arrayGenericForm.lblIdentifier && <p className="center-block d-flex flex-row ml-2 limit-text-center">
                                    {arrayGenericForm.lblIdentifier}
                                </p>}
                            </div>}
                            {arrayGenericForm.GeneralID.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faThLarge} />
                                    </div>
                                    <input type="text" className="form-control" name="GeneralID" disabled={!arrayGenericForm.GeneralID.Editable}
                                        aria-label="TransactionID" placeholder={arrayGenericForm.lblGeneralID === '' ? "TransactionID" : arrayGenericForm.lblGeneralID} required={arrayGenericForm.GeneralID.Required} />
                                </div>
                            </div>}
                            {arrayGenericForm.FirstName.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3" >
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faUser} />
                                    </div>
                                    <input type="text" className="form-control" name="FirstName" disabled={!arrayGenericForm.FirstName.Editable} value={clientInfo.Name}
                                        aria-label="FirstName" placeholder={arrayGenericForm.lblFirstName === '' ? "First Name" : arrayGenericForm.lblFirstName} required={arrayGenericForm.FirstName.Required} />
                                </div>
                            </div>}

                            {arrayGenericForm.LastName.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faUser} />
                                    </div>
                                    <input type="text" className="form-control" name="LastName" disabled={!arrayGenericForm.LastName.Editable} value={clientInfo.LastName}
                                        aria-label="LastName" placeholder={arrayGenericForm.lblLastName === '' ? "Last Name" : arrayGenericForm.lblLastName} required={arrayGenericForm.LastName.Required} />
                                </div>
                            </div>}

                            {arrayGenericForm.Phone.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3" >
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faPhone} />
                                    </div>
                                    <input type="text" className="form-control" name="Phone" disabled={!arrayGenericForm.Phone.Editable} value={arrayCustomerInfo.Phone}
                                        aria-label="Phone" placeholder={arrayGenericForm.lblPhone === '' ? "Phone" : arrayGenericForm.lblPhone} required={arrayGenericForm.Phone.Required} />
                                </div>
                            </div>}
                            {arrayGenericForm.Email.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3" ng-show="arrayGenericForm.Email.Visible">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faEnvelopeOpen} />
                                    </div>
                                    <input type="text" className="form-control" name="Email" disabled={!arrayGenericForm.Email.Editable} value={arrayCustomerInfo.Email}
                                        aria-label="Email" placeholder={arrayGenericForm.lblEmail === '' ? "Email" : arrayGenericForm.lblEmail} required={arrayGenericForm.Email.Required} />
                                </div>
                            </div>}

                            {arrayGenericForm.Country.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3" >
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faGlobe} />
                                    </div>
                                    <select className="form-select" name="Country" disabled={!arrayGenericForm.Country.Editable} required={arrayGenericForm.Country.Required}
                                        onChange={(event) => { setCountryCode(event.target.value); handleStatebyCountry(event.target.value, true) }}
                                        tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the Country" >
                                        {arrayCountries.map((item) => <option key={item.Key} selected={item.Code === arrayCustomerInfo.CountryCode} value={item.Code}>{item.Name}</option>)}
                                    </select>

                                </div>
                            </div>}
                            {arrayGenericForm.State.Visible && <div className="col-md-4 col-sm-4 col-xs-12  mb-3" >
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faGlobe} />
                                    </div>
                                    <select className="form-select" value={stateCode} name="StateCode" disabled={!arrayGenericForm.State.Editable} onChange={(event) => setStateCode(event.target.value)}
                                        tooltip-placement="bottom" tooltip-trigger="focus" tooltip-className="customClass" uib-tooltip="Select the State" required={arrayGenericForm.State.Required}>
                                        {arrayStates.map((item) => <option key={item.Key} selected={item.Code === arrayCustomerInfo.StateCode} value={item.Code}>{item.Name}</option>)}
                                    </select>

                                </div>
                            </div>}
                            {arrayGenericForm.City.Visible && <div className="col-md-4 col-sm-4 col-xs-12 mb-3" >
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faBuilding} />
                                    </div>
                                    <input type="text" className="form-control" name="City" disabled={!arrayGenericForm.City.Editable} value={arrayCustomerInfo.City}
                                        aria-label="City" placeholder={arrayGenericForm.lblCity === '' ? "City" : arrayGenericForm.lblCity} required={arrayGenericForm.City.Required} />
                                </div>
                            </div>}
                            {arrayGenericForm.ZipCode.Visible && <div className="col-md-4 col-sm-4 col-xs-12 mb-3">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faLocationArrow} />
                                    </div>
                                    <input type="text" className="form-control" name="ZipCode" disabled={!arrayGenericForm.ZipCode.Editable} value={arrayCustomerInfo.ZipCode}
                                        aria-label="ZipCode" placeholder={arrayGenericForm.lblZipCode === '' ? "Zip Code" : arrayGenericForm.lblZipCode} required={arrayGenericForm.ZipCode.Required} />
                                </div>
                            </div>}
                        </div>
                        <div className="row">
                            {arrayGenericForm.Address.Visible && <div className="col-md-6 col-sm-6 col-xs-12 mb-3" >
                                <div className="input-group " >
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faAddressCard} />
                                    </div>
                                    <input type="text" className="form-control" name="Address" disabled={!arrayGenericForm.Address.Editable} value={arrayCustomerInfo.Address}
                                        aria-label="Address" placeholder={arrayGenericForm.lblAddress === '' ? "Address" : arrayGenericForm.lblAddress} required={arrayGenericForm.Address.Required} />
                                </div>
                            </div>}
                            {arrayGenericForm.Address2.Visible && <div className="col-md-6 col-sm-6 col-xs-12 mb-3" >
                                <div className="input-group" >
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faAddressCard} />
                                    </div>
                                    <input type="text" className="form-control" name="Address2" disabled={!arrayGenericForm.Address2.Editable} value={arrayCustomerInfo.Address2}
                                        aria-label="Address2" placeholder={arrayGenericForm.lblAddress2 === '' ? "Address 2" : arrayGenericForm.lblAddress2} required={arrayGenericForm.Address2.Required} />
                                </div>
                            </div>}
                        </div>
                        <div className="row">
                            {arrayGenericForm.Notes.Visible && <div className="col-md-12 col-sm-12 col-xs-12 mb-3" >
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <FontAwesomeIcon className="input-group-fa" icon={faUniversity} />
                                    </div>
                                    <input type="text" className="form-control" name="Notes" disabled={!arrayGenericForm.Notes.Editable}
                                        aria-label="Notes" placeholder={arrayGenericForm.lblNotes === '' ? "Notes" : arrayGenericForm.lblAddress2} required={arrayGenericForm.Notes.Required} />
                                </div>
                            </div>}
                        </div>
                        <div >
                            {arrayGenericForm.Instructions != '' && (
                                <div className="row">
                                    <div className="col-md-2">&nbsp;</div>
                                    <div className="col-md-8 col-sm-12 col-xs-12 mb-3">
                                        <div className="input-group">
                                            <div className="alert alert-primary" role="alert" style={{ width: "100%" }}>
                                                {/*<FontAwesomeIcon className="input-group-fa" icon={faQuoteLeft} style={{ fontSize: "0.3em", backgroundColor: "#cfe2ff" }} />*/}
                                                <span dangerouslySetInnerHTML={{ __html: arrayGenericForm.Instructions }} />
                                                {/*<FontAwesomeIcon className="input-group-fa" icon={faQuoteRight} style={{ fontSize: "0.3em", backgroundColor: "#cfe2ff" }} />*/}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">&nbsp;</div>
                                </div>
                            )}
                        </div>
                        {/*bonus*/}
                        <Bonus ProcessorName={id} />
                        <div className="row">
                            <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                                <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/deposits/')}>{language === 'es' ? 'ATR\u00C1S' : 'BACK'}</button>
                                <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">{language === 'es' ? 'ENVIAR' : 'SUBMIT'}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}